<template>
  <v-card class="modal-peridic-ielty">
    <v-card-title class="font-weight-bold px-5">
      Kiểm tra
      <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-row class="py-3 justify-space-between">
        <v-col cols="3">
          <common-range-picker
            v-model="searchDate"
            label="Chọn ngày"
          ></common-range-picker>
        </v-col>
        <v-col cols="3" v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY">
          <div class="d-flex justify-space-between px-2 py-2" style="background-color: #e6f3ff;width: 70%;border-radius: 10px;float:right">
            <v-btn small class="d-flex mr-1" style="box-shadow: none" :class="typeData === 'self-study' ? 'active-btn' : ''" @click="switchData('self-study')"><v-icon small>mdi-account-star</v-icon> <span class="my-auto px-1 pt-1">Tự học</span></v-btn>
            <v-btn small class="d-flex" style="box-shadow: none" :class="typeData === TYPE_CURRICULUM_OBJ.ONLINE ? 'active-btn' : ''" :disabled="checkSelfStudy" @click="switchData(TYPE_CURRICULUM_OBJ.ONLINE)"><v-icon small>mdi-account-group</v-icon> <span class="my-auto px-1 pt-1">Gia sư</span></v-btn>
          </div>
        </v-col>
      </v-row>
      <v-simple-table class="table-layout table-overflow table-bordered" id="style-2">
        <thead>
          <tr>
            <th class="title px-1">Tên bài học</th>
            <th class="overall text-center">Overall</th>
            <th class="score text-center">Listening</th>
            <th class="score text-center">Reading</th>
            <th class="score text-center">Writing</th>
            <th class="score text-center">Speaking</th>
            <th v-if="moduleRoute === TYPE_CURRICULUM_OBJ.ONLINE" class="score text-center">Giáo viên ghi chú</th>
          </tr>
        </thead>
        <tbody v-if="typeData === 'self-study'">
           <tr
            v-for="(item, index) in data"
            :key="'contact' + index"
            style="cursor: pointer"
          >
            <td class="px-2">
              <div>
                <strong>{{ item.courseSectionCategoryName }}</strong>
              </div>
            </td>
            <td class="text-center">
              <span class="text-info">{{ item.overall.score || '-' }}</span>
            </td>
            <td class="score-col px-0">
              <div class="text-center py-2 text-info">
                <span>{{ showScoreNew(item, 'Listening') }}</span>
              </div>
            </td>
            <td class="score-col px-0">
              <div class="text-center py-2 text-info">
                <span>{{ showScoreNew(item, 'Reading') }}</span>
              </div>
            </td>
            <td class="score-col px-0">
              <div class="text-center py-2 text-info">
                <span>{{ showScoreNew(item, 'Writing') }}</span>
              </div>
            </td>
            <td class="score-col px-0">
              <div class="text-center py-2 text-info">
                <span>{{ showScoreNew(item, 'Speaking') }}</span>
              </div>
            </td>
            <td v-if="moduleRoute === TYPE_CURRICULUM_OBJ.ONLINE" class="score-col px-0">
              <div class="d-flex h-full"><span class="m-auto">--</span></div>
            </td>
          </tr>
           <tr v-if="!data.length">
            <td colspan="8">Không có dữ liệu!</td>
          </tr>
        </tbody>
        <tbody v-if="typeData === TYPE_CURRICULUM_OBJ.ONLINE">
          <tr
            v-for="(item, index) in data"
            :key="'contact' + index"
            style="cursor: pointer"
          >
            <td class="px-2">
              <div v-if="item.tag_lesson" class="tag-lesson mt-2" :style="{ color: item.tag_lesson.color, background: item.tag_lesson.background}">{{ item.tag_lesson.title }}</div>
              <div>
                <strong>{{ item.name }}</strong>
              </div>
              <div>{{ formatDate(item.lesson_start_time) }}</div>
              <div>Lớp {{ item.class_code }}</div>
            </td>
            <td class="text-center">
              <span class="text-info">{{ item.overall.score || '-' }}</span>
            </td>
            <td class="score-col px-0">
              <div class="score-item text-center py-2 text-info">
                <a v-if="!_.get(item, 'isGroupByLesson', false)  && _.get(item, 'lms_link_practice_result', '') !== ''
                        || _.get(item, 'isGroupByLesson', false)  && _.get(item, 'overall.listening_score_result_link', '')"
                  style="font-size:12px"
                  :href="_.get(item, 'isGroupByLesson', false) ? item.overall.listening_score_result_link : item.lms_link_practice_result"
                  target="_blank">{{ showScore(item.overall.listening_score) }}</a>
              </div>
              <CommentComponent v-if="item.overall.listening_score" :type="'Listening'" :item="item" />
              <div v-if="!item.overall.listening_score" class="text-center">-</div>
            </td>
            <td class="score-col px-0">
              <div class="score-item text-center py-2 text-info">
                <a v-if="!_.get(item, 'isGroupByLesson', false)  && _.get(item, 'lms_link_practice_result', '') !== ''
                        || _.get(item, 'isGroupByLesson', false)  && _.get(item, 'overall.reading_score_result_link', '')"
                  style="font-size:12px"
                  :href="_.get(item, 'isGroupByLesson', false) ? item.overall.reading_score_result_link : item.lms_link_practice_result"
                  target="_blank"
                >{{ showScore(item.overall.reading_score) || '-' }}</a>
              </div>
              <CommentComponent v-if="item.overall.reading_score" :type="'Reading'" :item="item" />
              <div v-if="!item.overall.reading_score" class="text-center">-</div>
            </td>
            <td class="score-col px-0">
              <div class="score-item text-center py-2 text-info">
                <a v-if="!_.get(item, 'isGroupByLesson', false)  && _.get(item, 'lms_link_practice_result', '') !== ''
                        || _.get(item, 'isGroupByLesson', false)  && _.get(item, 'overall.writing_score_result_link', '')"
                   style="font-size:12px"
                   :href="_.get(item, 'isGroupByLesson', false) ? item.overall.writing_score_result_link : item.lms_link_practice_result"
                   target="_blank"
                >{{ showScore(item.overall.writing_score) || '-' }}</a>
              </div>
              <CommentComponent v-if="item.overall.writing_score" :type="'Writing'" :item="item" />
              <div v-if="!item.overall.writing_score" class="text-center">-</div>
            </td>
            <td class="score-col px-0">
              <div class="score-item text-center py-2 text-info">{{ showScore(item.overall.speaking_score) || '-' }}</div>
              <CommentSpeakingComponent v-if="item.overall.speaking_score" :item="item" />
              <div v-if="!item.overall.speaking_score" class="text-center">-</div>
            </td>
            <td v-if="moduleRoute === TYPE_CURRICULUM_OBJ.ONLINE" class="score-col px-0">
              <HiddenLongString v-if="item.internal_note" :fullText="'The student did not complete the speaking test because:' + item.internal_note" >
                <template #show>Xem thêm</template>
                <template #hidden>Ẩn bớt</template>
              </HiddenLongString>
              <div v-else class="d-flex h-full"><span class="m-auto">--</span></div>
            </td>
          </tr>
          <tr v-if="!data.length">
            <td colspan="8">Không có dữ liệu!</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-pagination
        v-if="totalItems > 0"
        v-model="page"
        :length="Math.ceil(totalItems / this.limit)"
      ></v-pagination>
    </v-card-text>
    <v-card-actions class="pa-5 group-btn-comment">
      <v-btn color="error" @click="closeModal()">
        Thoát
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as moment from 'moment';
import { TYPE_CURRICULUM_OBJ, SCHOOL_LEVEL } from '@/helpers/constant';
import StudentCareServices from '@/services/StudentCareServices';

import HiddenLongString from '@/components/common/HiddenLongString.vue';
import CommentComponent from './CommentComponent.vue';
import CommentSpeakingComponent from './CommentSpeakingComponent.vue';

export default {
  props: {
    lmsCoreUserID: {
      type: Number,
      default: () => null,
    },
    selectedSubjectId: {
      type: Number,
      default: () => null,
    },
    selectedProgramId: {
      type: Number,
      default: () => null,
    },
  },
  components: {
    CommentComponent,
    CommentSpeakingComponent,
    HiddenLongString,
  },
  data() {
    return {
      TYPE_CURRICULUM_OBJ,
      SCHOOL_LEVEL,
      valueMonth: (new Date()).getMonth(),
      months: [
      ],
      searchDate: null,
      data: [],
      page: 1,
      limit: 10,
      totalItems: 0,
      typeData: 'online',
    };
  },
  computed: {
    moduleRoute() {
      return this.$route.query.typeCurriculum;
    },
    checkSelfStudy() {
      if (!this.selectedProgramId) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
      if (!this.selectedProgramId) this.typeData = 'self-study';
      this.getDataNew(this.typeData);
    } else {
      this.getData();
    }
  },
  watch: {
    searchDate() {
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        this.getDataNew(this.typeData);
      } else {
        this.getData();
      }
    },
    page() {
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        this.getDataNew(this.typeData);
      } else {
        this.getData();
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    formatDate(date) {
      const dayOfWeek = {
        1: 'T2',
        2: 'T3',
        3: 'T4',
        4: 'T5',
        5: 'T6',
        6: 'T7',
        0: 'CN',
      };
      if (date && date !== '') {
        const dow = moment(date).day();
        const day = moment(date).format('DD/MM');

        return `${dayOfWeek[dow]} - ${day}`;
      }
      return '--';
    },
    async getData() {
      const params = {
        lms_core_user_id: this.lmsCoreUserID,
        subject_id: this.selectedSubjectId,
        curriculum_id: this.selectedProgramId,
        page: this.page - 1,
        type: 2,
        limit: this.limit,
      };

      const res = await StudentCareServices.getPeriodicIeltYV2(params, this.searchDate);
      this.data = res.data;
      this.totalItems = res.totalItem;
    },
    showScore(text) {
      if (text) {
        const firstText = text.split('/');
        return firstText[0];
      }

      return '-';
    },
    async switchData(type) {
      if (type !== this.typeData) {
        this.data = [];
        this.typeData = type;
        this.searchDate = null;
        await this.getDataNew(type);
      }
    },
    async getDataNew(type) {
      const params = {
        lmsCoreUserId: this.lmsCoreUserID,
        curriculumId: type === TYPE_CURRICULUM_OBJ.ONLINE ? this.selectedProgramId : 0,
        type,
        startDate: this.searchDate ? this.searchDate[0] : null,
        endDate: this.searchDate ? this.searchDate[1] : null,
        page: this.page - 1,
      };
      const loading = this.$loading.show();
      const res = await StudentCareServices.getCarePeriodicNew(params);
      if (res && res.data) {
        this.data = res.data;
        this.totalItems = res.totalItem;
      }
      loading.hide();
    },
    showScoreNew(item, type) {
      const score = item.skills.find((skill) => skill.folderName === type);
      if (score) {
        if (score.gradingScale === 0) {
          return (score.correctQuestion || score.correctQuestion === 0) ? `${score.correctQuestion}/${score.totalQuestions}` : '-';
        }
        if (score.gradingScale === 1) {
          return (score.bandScore || score.bandScore === 0) ? score.bandScore : '-';
        }
        if (score.gradingScale === 2) {
          return (score.hundredScore || score.hundredScore === 0) ? `${score.hundredScore}/100` : '-';
        }
        if (score.gradingScale === 4) {
          return (score.correctQuestion || score.correctQuestion === 0) ? parseFloat(score.correctQuestion / score.totalQuestions).toFixed(2) : '-';
        }
      }
      return '-';
    },
  },
};
</script>
<style lang="scss" scoped>
.active-btn {
  background-color: #1187CA !important;
  color: white !important;
}
.group-btn-comment {
  display: flex;
  float: right;
}
.modal-peridic-ielty {
  .table-layout {
    min-height: 450px;
  }
  .tag-lesson {
    display: inline-block;
    padding: 0 5px;
    border-radius: 5px;
  }
  th {
    border: 1px solid #ccc;
  }
  td {
    border: 1px solid #ccc;
  }
  .title {
    width: 15%;
  }
  .start-time {
    width: 9%;
  }
  .class-code {
    width: 10%;
  }
  .overall {
    width: 5%;
  }
  .score {
    width: 15%;
  }
  .score-col {
    vertical-align: top;
  }
  .score-item {
    border-bottom: 1px solid #ccc
  }
  .text-info {
    color: #1187CA;
  }
}
</style>
<style lang="scss">
.modal-peridic-ielty {
  .s-datepicker-range label {
    z-index: 999;
  }
}
</style>
